import { User } from 'lucide-react';

interface InstructorCardProps {
  id: string;
  name: string;
  description: string;
  imageUrl: string | null;
  onClick: () => void;
}

export default function InstructorCard({
  name,
  description,
  imageUrl,
  onClick,
}: InstructorCardProps) {
  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl shadow-soft hover:shadow-lg transition-shadow cursor-pointer group"
    >
      {/* Profile Image */}
      <div className="relative">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            className="w-full block rounded-t-xl object-cover bg-gray-100"
            style={{ aspectRatio: '1/1' }}
          />
        ) : (
          <div className="w-full rounded-t-xl bg-gray-100 flex items-center justify-center" style={{ aspectRatio: '1/1' }}>
            <User className="w-16 h-16 text-gray-400" />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-semibold text-gray-900 group-hover:text-primary transition-colors">
          {name}
        </h3>
        {description && (
          <p className="text-sm text-gray-500 mt-1 line-clamp-2 whitespace-pre-line">
            {description
              .replace(/<br\s*\/?>/gi, '\n')
              .replace(/<\/p>/gi, '\n')
              .replace(/<[^>]+>/g, '')
              .trim()}
          </p>
        )}
      </div>
    </div>
  );
}
